import styled, { css } from 'styled-components';
import { selectColor } from '@panel/commons';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const LeadsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  ${({ isDesktop }) =>
    !isDesktop &&
    css`
      flex-direction: column;
      margin-bottom: 0;
      .separator {
        width: calc(100% + 10px);
        height: 1px;
        background-color: ${selectColor('grayMedium')};
        margin: 3px 0 16px -5px;
      }
    `}
`;

export { Container, LeadsWrapper };
